import { useCallback, useState } from "react";
import { Stack, useResponsive } from "capitalrx-components-2.0/lib/layout";
import { DesktopMenuBar, MobileMenuBar, MobileMenuDrawer } from "@/premium/themedComponents/MenuBar";

export const MenuBar = () => {
  const [mobileDrawerVisible, setMobileDrawerVisible] = useState(false);

  const { isMobile } = useResponsive({
    isMobile: {
      mobile: true,
      desktop: false,
    },
  });

  const onMobileMenuToggle = useCallback(() => {
    const visible = !mobileDrawerVisible;
    if (visible) {
      window.scrollTo(0, 0);
    }
    setMobileDrawerVisible(visible);
  }, [mobileDrawerVisible]);

  return (
    <Stack spacing="none">
      {!isMobile && <DesktopMenuBar/>}
      {isMobile && (
        <>
          <MobileMenuBar mobileMenuIcon={mobileDrawerVisible ? "x" : "menu-bars"} onMobileMenuToggle={onMobileMenuToggle} />
          <MobileMenuDrawer isVisible={mobileDrawerVisible} setVisible={setMobileDrawerVisible}/>
        </>
      )}
    </Stack>
  );
};
